<template>
  <div class="container-xxl">
    <header class="d-flex flex-wrap justify-content-center py-3 mb-2 mt-3">
      <a
        href="/"
        class="
          d-flex
          align-items-center
          my-2 my-lg-0
          me-lg-auto
          text-decoration-none
        "
      >
        <img
          class="bi me-2"
          src="@/assets/img/FPGDKG.png"
          alt="home"
          width="67"
          height="85"
        />
      </a>

      <!-- <b-nav >
        <b-nav-item active to="/home" exact exact-active-class="active">Home</b-nav-item>
        <b-nav-item to="/search">Search</b-nav-item>
        <b-nav-item to="/visualization">KG Tool</b-nav-item>
        <b-nav-item to="/statistic">Visualization</b-nav-item>
        <b-nav-item to="/contactus">Contact US</b-nav-item>
       <b-nav-item to="/help">Help</b-nav-item> 
      </b-nav> -->
      <el-menu
      :default-active="this.$route.path"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      router
      background-color="#fff"
      text-color="#333"
      active-text-color="#0084ff"
      style="flex:1;"
      

    >
      <el-menu-item  v-for="(item, i) in navList" :key="i" :index="item.name" style="float: right;" >
        <template slot="title">
          <span> {{ item.navItem }}</span>
        </template>
      </el-menu-item>
    </el-menu>


      <!-- <nav class="navbar navbar-expand-lg justify-content-end nav-pills nav-fill " aria-label="Fifth navbar example">
    <div class="container-fluid">
      <div class="collapse navbar-collapse" id="navbarsExample05">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <button class="nav-link active" aria-current="page" href="/home">Home</button> 
            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="/home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Home</button>
          </li>
          <li class="nav-item">
            <button class="nav-link " aria-current="page" href="/search">Search</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" aria-current="page" href="/visualization">KG Tool</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" aria-current="page" href="/statistic">Visualization</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" aria-current="page" href="/help">Contact US</button>
          </li>
        </ul>
       
      </div>
    </div>
  </nav>  -->

      <!-- <ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small ">
                <li class="nav-item">
                    <a href="home" class="nav-link  " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/home.svg" alt="home" width="24"
                             height="24">
                        Home
                    </a>
                </li>
                <li class="nav-item">
                    <a href="search" class="nav-link " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/search.svg" alt="home" width="24"
                             height="24">
                        Search
                    </a>
                </li>
                <li class="nav-item">
                    <a href="vis" class="nav-link " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/vis.svg" alt="home" width="24"
                             height="24">
                        Visualization
                    </a>
                </li>
                <li class="nav-item">
                    <a href="statistic" class="nav-link " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/statistics.svg" alt="home"
                             width="24"
                             height="24">
                        Statistics
                    </a>
                </li>
                <li class="nav-item">
                    <a href="contact" class="nav-link " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/contact.svg" alt="home" width="24"
                             height="24">
                        Contact US
                    </a>
                </li>
                <li class="nav-item">
                    <a href="help" class="nav-link " aria-current="page">
                        <img class="bi d-block mx-auto mb-1" src="@/assets/img/help.svg" alt="home" width="24"
                             height="24">
                        Help
                    </a>
                </li>
            </ul> -->
      <!-- <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">Home</el-menu-item>
          <el-menu-item index="2">Search</el-menu-item>
          <el-menu-item index="3">Visualization</el-menu-item>
          <el-menu-item index="4">Statistics</el-menu-item>
          <el-menu-item index="5">Contact US</el-menu-item>
          <el-menu-item index="6">Help</el-menu-item>
        </el-menu> -->
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      navList:[
        {name:'/help',navItem:'Help'},
        {name:'/contactus',navItem:'Contact US'},
        {name:'/statistic',navItem:'Visualization'},
        {name:'/visualization',navItem:'Diagnosis & Matching'},
        {name:'/search',navItem:'Search'},
        {name:'/home',navItem:'Home'},
        
      ]
    };
  },
  methods: {
    handleSelect() {
      // console.log(key, keyPath);
    },
  },
};
</script>

<style>
.el-menu-item{
  font-size: 18px !important;
}
.el-menu-item.is-active {
    color: #2856ed !important;
    font-size: 18px !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #2856ed !important;
}

</style>